import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import pageTitles from 'consts/pageTitleConsts';

import { useVendorsIframe } from 'explat/useVendorsIframe';

import { useTimeToCompleteEnrollment } from 'hooks/useCaptureTimeOnPage';

import { selectEnrollmentEnrolledInCredit } from 'selectors/enrollment';

import {
  Card,
  ChimeLogo,
  DescriptionText,
  PageTitle,
  PageWrapper,
} from 'styles/styleMixins';

import {
  executeOathScript,
  loadGoogleAnalytics,
  loadGoogleTagManager,
} from 'utils/postEnrollmentHelper';
import { trackEnrollmentDeclinePageViewed } from 'utils/segment/pageEvents';

const Title = styled(PageTitle)`
  color: ${props => props.theme.colors['content-primary']};
  font-family: ${props => props.theme.fonts.headerFont};
  font-weight: 700;
  text-align: left;
`;

const Content = styled(DescriptionText)`
  color: ${props => props.theme.colors['content-primary']};
  font-family: ${props => props.theme.fonts.primaryFont};
  margin-top: 20px;
  text-align: left;
`;

const DeclineCard = styled(Card)`
  padding: 26px 80px 35px;
`;
const DeclinePage = () => {
  const enrolledInCredit = useSelector(selectEnrollmentEnrolledInCredit);

  const SpendingAccountOnlyDescription = 'Chime Deposit Account';

  const SpendingAndCreditAccountDescription = `Chime Checking Account and Credit Builder`;

  const AccountDescription = enrolledInCredit
    ? SpendingAndCreditAccountDescription
    : SpendingAccountOnlyDescription;

  useTimeToCompleteEnrollment();

  const {
    isLoaded: isVendorsExperimentLoaded,
    isVariant: isVendorsIframeVariant,
  } = useVendorsIframe();

  useEffect(() => {
    trackEnrollmentDeclinePageViewed();
    executeOathScript();
    loadGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (isVendorsExperimentLoaded) {
      if (!isVendorsIframeVariant) {
        loadGoogleTagManager();
      }
    }

    window?.scrollTo(0, 0);
  }, [isVendorsExperimentLoaded, isVendorsIframeVariant]);

  return (
    <PageWrapper>
      <DeclineCard>
        <ChimeLogo />
        <Title>{pageTitles.DECLINE_PAGE}</Title>
        <Content>
          {`Unfortunately, based on the information provided, we were unable to
            open a ${AccountDescription} for you at this time. Due to security
            reasons, our Member Services team is unable to provide you with any
            further information.`}
        </Content>
      </DeclineCard>
    </PageWrapper>
  );
};

DeclinePage.propTypes = {
  enrolledInCredit: PropTypes.bool,
};

export default DeclinePage;
